<template>
  <div class="row gfol">
    <div class="green-fitout__header small-12">
      {{ $t('tenantProjects.guideline') }}
    </div>
    <div class="small-12">
      <PostFitOutGuideline
        class="green-fitout__body guidelines"
        :guidelines="publishedGuideLines"
      />
    </div>
  </div>
</template>

<script>
import { onBeforeMount, ref } from '@vue/composition-api'

import { getGuidelines } from '@/api/settings/request'
import { GUIDELINE_TYPE } from '@/modules/settings/engineers/consts'
import PostFitOutGuideline from '@/modules/tenantProjects/postFitOutLetter/PostFitOutGuideline'
import { GUIDELINE_STATUS } from '@/utils/locale'
import { sortGuidelines } from './utils'

export default {
  components: {
    PostFitOutGuideline,
  },
  setup () {
    const publishedGuideLines = ref([])
    onBeforeMount(async () => {
      const result = await getGuidelines(GUIDELINE_STATUS.PUBLISHED, GUIDELINE_TYPE.GREEN_FITOUT)
      publishedGuideLines.value = sortGuidelines(result.guidelines) || []
    })

    return {
      publishedGuideLines,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './style.scss';

</style>
